import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceImportDTO  {
    _originalTypeClassName = "zERP.BO.InvoiceImportDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceImportDTO.translate = translateService;
}
this.InvoiceTypeDescription = null;
this.IssueDate = null;
this.Series = null;
this.AA = null;
this.InvoiceCode = null;
this.TransactionEntityName = null;
this.NetAmount = null;
this.VATPercent = null;
this.CounterpartVATNumber = null;
this.ExpensesAccountNumber = null;
this.Reason = null;
this.InvoiceLineNumber = null;
this.VATAccount = null;
this.InvoiceImportDTOKey = null;
this._key = this.InvoiceImportDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
InvoiceTypeDescription:any;
IssueDate:any;
Series:any;
AA:any;
InvoiceCode:any;
TransactionEntityName:any;
NetAmount:any;
VATPercent:any;
CounterpartVATNumber:any;
ExpensesAccountNumber:any;
Reason:any;
InvoiceLineNumber:any;
VATAccount:any;
private _InvoiceImportDTOKey:any;
get InvoiceImportDTOKey(): any {
    return this._InvoiceImportDTOKey;
  }
set InvoiceImportDTOKey(value: any) {
    this._InvoiceImportDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InvoiceImportDTOKey == null || $this.InvoiceImportDTOKey == 0;
            }


}